export default "__VITE_ASSET__D4$KFrD5__"